import $ from 'jquery';
import moment from 'moment'; // Import Moment here

import 'jquery-validation';
// Expose Moment (This fixes "moment is not defined")
window.moment = moment;
